import { useState, FocusEvent } from "react";
import { Controller, get } from "react-hook-form";
import { Eye, EyeOff } from "lucide-react";
import { TextField } from "../../ui";

export interface InputSenhaProps {
  name: string;
  label: string;
  methods: any;
  helperText?: string;
  disabled?: boolean;
  onBlur?: (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  // Prop aceita por compatibilidade (não utilizada, era espaçamento MUI)
  sx?: any;
}

export default function InputSenha({
  name,
  label,
  methods,
  helperText,
  disabled,
  onBlur,
}: InputSenhaProps) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Controller
      name={name}
      control={methods.control}
      render={({ field, formState: { errors } }) => {
        const error = get(errors, name);
        return (
          <TextField
            {...field}
            label={label}
            type={showPassword ? "text" : "password"}
            helperText={error?.message || helperText}
            error={!!error}
            disabled={disabled}
            onBlur={onBlur || field.onBlur}
            endAdornment={
              <button
                type="button"
                tabIndex={-1}
                aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                onClick={() => setShowPassword((prev) => !prev)}
                className="flex h-6 w-6 items-center justify-center rounded text-slate-400 hover:text-slate-600 dark:hover:text-slate-200"
              >
                {showPassword ? (
                  <EyeOff className="h-4 w-4" />
                ) : (
                  <Eye className="h-4 w-4" />
                )}
              </button>
            }
          />
        );
      }}
    />
  );
}
